<template>
  <div @click="openModal">
    <button
      class="bg-orange-600 px-4 text-white rounded font-inter py-2"
      @click="isAddVehiclePopUpOpen = true"
    >
      <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />
      New Trip
    </button>
  </div>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" @close="closeModal" class="relative z-10">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-5xl transform overflow-hidden rounded-md bg-white text-left align-middle shadow-xl transition-all overflow-y-auto"
            >
              <DialogTitle as="h3">
                <div class="flex justify-between my-5 mx-4">
                  <p class="text-lg text-gray-600 font-inter leading-6">
                    New Trip
                  </p>
                  <font-awesome-icon
                    :icon="['fas', 'xmark']"
                    class="h-6 w-6 text-gray-400"
                    @click="closeModal"
                  />
                </div>
                <hr />
              </DialogTitle>
              <div class="p-6 bg-white">
                <form @submit.prevent="saveVehicleTrip">
                  <!-- First row starts here -->
                  <div class="grid grid-cols-3 space-x-2 font-inter">
                    <div>
                      <label
                        for="customer-name"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Sales Order Number</label
                      >
                      <div class="relative">
                        <div
                          class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'hashtag']"
                            class="text-gray-400"
                          />
                        </div>

                        <input
                          type="text"
                          id="customer-name"
                          v-model="vehicleTripDataArray.SalesOrderNo"
                          class="block ps-10 py-2 text-sm text-black border border-gray-300 rounded-lg w-full font-inter focus:border-orange-400 focus:ring-orange-400"
                          placeholder="Sales Order Number"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        for="pick-up"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Pick Up</label
                      >
                      <div class="relative">
                        <div
                          class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'location-dot']"
                            class="text-gray-400"
                          />
                        </div>

                        <input
                          type="text"
                          id="pick-up"
                          v-model="vehicleTripDataArray.PickUp"
                          class="block ps-10 py-2 text-sm text-gray-900 border border-gray-300 rounded-lg w-full font-inter focus:border-orange-400 focus:ring-orange-400"
                          placeholder="e.g Mombasa Port"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        for="destination"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Destination</label
                      >
                      <div class="relative">
                        <div
                          class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'map-pin']"
                            class="text-gray-400"
                          />
                        </div>

                        <input
                          id="destination"
                          v-model="vehicleTripDataArray.Destination"
                          type="text"
                          class="block ps-10 py-2 text-sm text-gray-900 border border-gray-300 rounded-lg w-full font-inter focus:border-orange-400 focus:ring-orange-400"
                          placeholder="e.g Kampala"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <!-- First row ends here -->
                  <!-- Second row starts here -->
                  <!-- <div class="grid grid-cols-3 space-x-2 font-inter mt-6">
                    <div>
                      <label
                        for="total-amount"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Total Amount</label
                      >
                      <div class="relative">
                        <div
                          class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'money-bill-wave']"
                            class="text-gray-400"
                          />
                        </div>

                        <input
                          id="total-amount"
                          v-model="vehicleTripDataArray.TotalAmount"
                          type="number"
                          class="block ps-10 py-2 text-sm text-black border border-gray-300 rounded-lg w-full font-inter focus:border-orange-400 focus:ring-orange-400"
                          placeholder="e.g. 20,000"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        for="pickup-date"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Scheduled Pick Up Date</label
                      >
                      <vue-tailwind-datepicker
                        v-model="selectedPickUpDate"
                        :formatter="formatter"
                        as-single
                        placeholder="Pick-up Date"
                        input-classes="rounded-lg border-gray-300 font-inter text-sm font-light focus:border-orange-400 focus:ring-orange-400"
                      />
                    </div>
                    <div>
                      <label
                        for="customer-name"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Scheduled Drop Off Date</label
                      >
                      <vue-tailwind-datepicker
                        v-model="selectedDropOffDate"
                        :formatter="formatter"
                        as-single
                        placeholder="Trip Date"
                        input-classes="rounded-lg border-gray-300 font-inter text-sm font-light focus:border-orange-400 focus:ring-orange-400"
                      />
                    </div>
                  </div> -->
                  <!-- Second row ends here -->
                  <!-- Third row starts here -->
                  <div class="grid grid-cols-3 space-x-2 font-inter mt-6">
                    <!-- Driver dropdown -->
                    <div>
                      <label
                        for="driver"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Driver</label
                      >
                      <div class="w-full">
                        <Combobox v-model="selectedDriver">
                          <div class="relative mt-1">
                            <div
                              class="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm font-inter border border-gray-300"
                            >
                              <ComboboxInput
                                class="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
                                :displayValue="(driver) => driver.email_address"
                                @change="
                                  driverSearchQueryString = $event.target.value
                                "
                              />
                              <ComboboxButton
                                class="absolute inset-y-0 right-0 flex items-center pr-2"
                              >
                                <font-awesome-icon
                                  :icon="['fas', 'chevron-down']"
                                  class="h-3 w-3 text-gray-400"
                                />
                              </ComboboxButton>
                            </div>
                            <TransitionRoot
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                              @after-leave="driverSearchQueryString = ''"
                            >
                              <ComboboxOptions
                                class="absolute mt-1 max-h-40 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-10"
                              >
                                <div
                                  v-if="
                                    filteredDriversList.length === 0 &&
                                    driverSearchQueryString !== ''
                                  "
                                  class="relative cursor-default select-none px-4 py-2 text-gray-700"
                                >
                                  Driver not found
                                </div>

                                <ComboboxOption
                                  v-for="(driver, index) in filteredDriversList"
                                  as="template"
                                  :key="index"
                                  :value="driver"
                                  v-slot="{ selectedDriver, active }"
                                >
                                  <li
                                    class="relative cursor-default select-none py-2 pl-10 pr-4"
                                    :class="{
                                      'bg-orange-600 text-white': active,
                                      'text-gray-900': !active,
                                    }"
                                  >
                                    <span
                                      class="block truncate"
                                      :class="{
                                        'font-medium': selectedDriver,
                                        'font-normal': !selectedDriver,
                                      }"
                                    >
                                      {{ driver.email_address }}
                                    </span>
                                    <span
                                      v-if="selectedDriver"
                                      class="absolute inset-y-0 left-0 flex items-center pl-3"
                                      :class="{
                                        'text-white': active,
                                        'text-orange-600': !active,
                                      }"
                                    >
                                      <CheckIcon
                                        class="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                    </span>
                                  </li>
                                </ComboboxOption>
                              </ComboboxOptions>
                            </TransitionRoot>
                          </div>
                        </Combobox>
                      </div>
                    </div>
                    <!-- Vehicle DropDown -->
                    <div>
                      <label
                        for="vehicle"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Vehicle</label
                      >
                      <div class="w-full">
                        <Combobox v-model="selectedVehicle">
                          <div class="relative mt-1">
                            <div
                              class="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm font-inter border border-gray-300"
                            >
                              <ComboboxInput
                                class="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
                                :displayValue="(vehicle) => vehicle.NumberPlate"
                                @change="vehicleQuery = $event.target.value"
                              />
                              <ComboboxButton
                                class="absolute inset-y-0 right-0 flex items-center pr-2"
                              >
                                <font-awesome-icon
                                  :icon="['fas', 'chevron-down']"
                                  class="h-3 w-3 text-gray-400"
                                />
                              </ComboboxButton>
                            </div>
                            <TransitionRoot
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                              @after-leave="vehicleQuery = ''"
                            >
                              <ComboboxOptions
                                class="absolute mt-1 max-h-40 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-10"
                              >
                                <div
                                  v-if="
                                    vehiclesList.length === 0 &&
                                    vehicleQuery !== ''
                                  "
                                  class="relative cursor-default select-none px-4 py-2 text-gray-700"
                                >
                                  Vehicle not found
                                </div>

                                <ComboboxOption
                                  v-for="(vehicle, index) in vehiclesList"
                                  as="template"
                                  :key="index"
                                  :value="vehicle"
                                  v-slot="{ selectedVehicle, active }"
                                >
                                  <li
                                    class="relative cursor-default select-none py-2 pl-10 pr-4"
                                    :class="{
                                      'bg-orange-600 text-white': active,
                                      'text-gray-900': !active,
                                    }"
                                  >
                                    <span
                                      class="block truncate"
                                      :class="{
                                        'font-medium': selectedVehicle,
                                        'font-normal': !selectedVehicle,
                                      }"
                                    >
                                      {{ vehicle.NumberPlate }}
                                    </span>
                                    <span
                                      v-if="selectedVehicle"
                                      class="absolute inset-y-0 left-0 flex items-center pl-3"
                                      :class="{
                                        'text-white': active,
                                        'text-orange-600': !active,
                                      }"
                                    >
                                      <CheckIcon
                                        class="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                    </span>
                                  </li>
                                </ComboboxOption>
                              </ComboboxOptions>
                            </TransitionRoot>
                          </div>
                        </Combobox>
                      </div>
                    </div>
                    <div>
                      <label
                        for="cargo-type"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Cargo Type</label
                      >
                      <div class="relative">
                        <div
                          class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'trailer']"
                            class="text-gray-400"
                          />
                        </div>
                        <input
                          id="cargo-type"
                          v-model="vehicleTripDataArray.CargoType"
                          type="text"
                          class="block ps-10 py-2 text-sm text-gray-900 border border-gray-300 rounded-lg w-full font-inter focus:border-orange-400 focus:ring-orange-400"
                          placeholder="e.g Loose/Container"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <!-- Third row ends here -->
                  <!-- Fourth row starts here -->
                  <div class="grid grid-cols-3 space-x-2 font-inter my-6">
                    <!-- <div>
                      <label
                        for="cargo-contents"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Cargo Contents</label
                      >
                      <div class="relative">
                        <div
                          class="absolute inset-y-0 start-0 ps-3 pointer-events-none mt-2"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'box-open']"
                            class="text-gray-400"
                          />
                        </div>

                        <textarea
                          id="cargo-contents"
                          v-model="vehicleTripDataArray.CargoContents"
                          rows="4"
                          class="font-inter block p-2.5 ps-10 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-orange-400 focus:border-orange-400"
                          placeholder="A description of contents of the cargo"
                          required
                        ></textarea>
                      </div>
                    </div> -->

                    <div>
                      <label
                        for="trip-type"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Trip Type</label
                      >
                      <div class="relative">
                        <div
                          class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'route']"
                            class="text-gray-400"
                          />
                        </div>

                        <input
                          v-model="vehicleTripDataArray.TripType"
                          type="text"
                          id="trip-type"
                          class="block ps-10 py-2 text-sm text-black border border-gray-300 rounded-lg w-full font-inter focus:border-orange-400 focus:ring-orange-400"
                          placeholder="e.g. Local/Transit"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        for="special-instructions"
                        class="block mb-2 text-xs font-medium text-gray-900 uppercase"
                        >Special Instructions</label
                      >
                      <div class="relative">
                        <div
                          class="absolute inset-y-0 start-0 ps-3 pointer-events-none mt-2"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'note-sticky']"
                            class="text-gray-400"
                          />
                        </div>

                        <textarea
                          id="special-instructions"
                          v-model="vehicleTripDataArray.SpecialInstructions"
                          rows="4"
                          class="font-inter block p-2.5 ps-10 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-orange-400 focus:border-orange-400"
                          placeholder="Any special instructions to be shown to the driver"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <!-- Fourth row ends here -->
                  <!-- Documents upload section starts here -->
                  <!-- <div class="my-6">
                    <label
                      for="customer-name"
                      class="block mb-2 text-xs font-medium text-gray-900 uppercase font-inter"
                      >Documents</label
                    >
                    <div
                      class="grid place-content-center border border-gray-300 border-dashed border-rounded-lg w-24 h-24"
                    >
                      <font-awesome-icon :icon="['fas', 'plus']" />
                    </div>
                  </div> -->
                  <hr />
                  <!-- Documents upload section ends here -->
                  <div class="flex justify-between w-full mt-6 items-center">
                    <p
                      class="font-inter text-red-700 cursor-pointer"
                      @click="closeModal"
                    >
                      Cancel
                    </p>
                    <div>
                      <p
                        v-show="errorOccurred"
                        class="mb-1 font-inter text-red-700"
                      >
                        {{ errorMessage }}
                      </p>
                      <button
                        type="submit"
                        class="uppercase font-inter bg-orange-600 rounded-lg text-xs text-white py-2.5 px-5 place-self-center w-44"
                        :class="isSavingTrip ? 'hidden' : 'block'"
                      >
                        save
                      </button>
                      <button
                        disabled
                        type="button"
                        class="py-2.5 px-5 me-2 text-sm font-medium text-gray-900 bg-gray-200 rounded-lg border border-gray-200 inline-flex items-center font-inter"
                        :class="isSavingTrip ? 'block' : 'hidden'"
                      >
                        <svg
                          aria-hidden="true"
                          role="status"
                          class="inline w-4 h-4 me-3 text-gray-200 animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#78716c"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="#ea580c"
                          />
                        </svg>
                        Saving...
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
} from "@headlessui/vue";
</script>
<script>
import DataRepository from "@/infrastructure/services/DataRepository";
export default {
  emits: ["uploadSuccess"],
  computed: {
    vehiclesList() {
      const filteredVehiclesList =
        this.vehicleQuery == ""
          ? this.$store.state.vehiclesArrayList
          : this.$store.state.vehiclesArrayList.filter((vehicle) => {
              return (
                vehicle.NumberPlate.toLowerCase().indexOf(
                  this.vehicleQuery.toLowerCase()
                ) > -1
              );
            });
      return filteredVehiclesList;
    },
    filteredDriversList() {
      const filterDriversList =
        this.driverSearchQueryString == ""
          ? this.driversList
          : this.driversList.filter((driver) => {
              return (
                driver.email_address
                  .toLowerCase()
                  .indexOf(this.driverSearchQueryString.toLowerCase()) > -1
              );
            });
      return filterDriversList;
    },
  },
  watch: {
    selectedVehicle(newValue) {
      this.vehicleTripDataArray.VehicleID = newValue.VehicleID;
    },
  },
  data() {
    return {
      vehicleTripDataArray: {
        SalesOrderNo: "",
        CargoType: "",
        VehicleID: "",
        DriverID: "4f2b9860-86b4-461d-8a50-c435f8f48808",
        PickUp: "",
        Destination: "",
        TripType: "",
        SpecialInstructions: "",
      },
      isOpen: false,
      isSavingTrip: false,
      errorMessage: "",
      errorOccurred: false,
      vehicleQuery: "",
      selectedVehicle: "",
      driversList: [],
      driverSearchQueryString: "",
      selectedDriver: "",
    };
  },
  methods: {
    closeModal() {
      this.isOpen = false;
    },
    openModal() {
      this.isOpen = true;
    },
    async saveVehicleTrip() {
      this.isSavingTrip = true;
      const response = await DataRepository.addNewVehicleTrip(
        this.vehicleTripDataArray
      );

      this.isSavingTrip = false;

      if (response.error) {
        // if error occurs
        this.errorOccurred = true;
        this.errorMessage = `Failed! Trip not saved. ${response.error.message}`;
      } else {
        this.errorOccurred = false;
        // Send an emit to parent of completed upload of a new trip
        this.$emit("uploadSuccess");
        this.closeModal();
      }
    },
    isDatesValid(startDate, endDate) {
      const pickUpDate = new Date(startDate);
      const dropOffDate = new Date(endDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (dropOffDate < pickUpDate) {
        return false;
      }
      if (pickUpDate < today || dropOffDate < today) {
        return false;
      }
      return true;
    },
    async getDrivers() {
      const response = await DataRepository.fetchDrivers();
      if (response.success && !response.error) {
        this.driversList = response.success;
      }
    },
  },
  mounted() {
    this.$store.dispatch("fetchVehicles");
    this.getDrivers();
  },
};
</script>
